import { apiSlice } from '../../api/api-slice';
import {
    CardListRequest,
    CardListResponse,
    CardTitleListResponse,
} from 'types/card/card-list';

export const cardListApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        cardList: builder.query<CardListResponse, CardListRequest>({
            query: (params) => ({
                url: '/card/card-list',
                method: 'GET',
                params,
            }),
        }),

        cardTitleList: builder.query<CardTitleListResponse[], string>({
            query: (cardTitle: string) => ({
                url: `/card/card-title-list?cardTitle=${cardTitle}`,
                method: 'GET',
            }),
        }),

        cardCategory: builder.query<string[], void>({
            query: () => ({
                url: '/card/card-category-enum',
                method: 'GET',
            }),
        }),

        gameCategoryList: builder.query<string[], void>({
            query: () => ({
                url: '/card/user-card-game-enum',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useLazyCardListQuery,
    useCardCategoryQuery,
    useCardTitleListQuery,
    useGameCategoryListQuery,
} = cardListApi;
